import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePremium from "./pages/HomePremium";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePremium />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;